module.exports = __webpack_public_path__ + "img/event-frame03.b70ec687.png";